import { HttpStatus } from '../types/api.types';
import BaseApiResponseError from './BaseApiResponseError';

/**
 * The message every 429 carries, whatever the backend said: a validation KEY, so the
 * surfaces that already translate server sentences (the AuthProvider toast,
 * `ErrorMessage`) show translated copy instead of the throttler's English
 * "ThrottlerException: Too Many Requests". The copy names no duration on purpose — one
 * throttle bucket blocks for a minute, another for an hour.
 */
export const TOO_MANY_REQUESTS_MESSAGE = 'VALIDATION__TooManyRequests' as const;

/** A throttle refusal (HTTP 429): too many attempts, not a server fault. */
export default class TooManyRequestsError<
  TErrors,
> extends BaseApiResponseError<TErrors> {
  constructor() {
    super({
      errors: null,
      message: TOO_MANY_REQUESTS_MESSAGE,
      status: HttpStatus.TooManyRequests,
    });
  }
}
